module.exports = __webpack_public_path__ + "img/load-mask.17c56ad0.png";